
// 不需要动态判断权限的路由
const Home = () => import(/* webpackChunkName: 'home' */'@/views/Home')
const Details = () => import(/* webpackChunkName: 'home' */'@/views/Details')
const Pdf = () => import(/* webpackChunkName: 'home' */'@/views/Pdf')
const PdfT = () => import(/* webpackChunkName: 'home' */'@/views/PdfT')
const Index = () => import(/* webpackChunkName: 'home' */'@/views/Index')
const Success = () => import(/* webpackChunkName: 'home' */'@/views/Success')
const Compare = () => import(/* webpackChunkName: 'home' */'@/views/compare')


const routes = [

  {
    path: '/index',
    name: 'Index',
    component: Index,
    meta: {
      title: '知情同意书',
      keepAlive: false
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: {
      title: '知情同意书',
      keepAlive: true
    }
  },
  {
    path: '/details',
    name: 'Details',
    component: Details,
    meta: {
      title: '知情同意书详情',
      keepAlive: false
    }
  },
  {
    path: '/success',
    name: 'Success',
    component: Success,
    meta: {
      title: '入组成功',
      keepAlive: false
    }
  },
  {
    path: '/pdf',
    name: 'Pdf',
    component: Pdf
  },
  {
    path: '/compare',
    name: 'Compare',
    component: Compare
  },
  {
    path: '/pdfT',
    name: 'PdfT',
    component: PdfT
  },
  {
    path: '*',
    redirect: '/index'
  }
]

export default routes
